import { render } from "./RestaurantsPage.vue?vue&type=template&id=901b8cfa"
import script from "./RestaurantsPage.vue?vue&type=script&lang=ts"
export * from "./RestaurantsPage.vue?vue&type=script&lang=ts"
script.render = render

export default script